export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új engedély',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Mentés és nyomtatás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class mx-1",
                event_payload: 'saveAndPrint'
            }
        ],
        rowActions: [
            {
                btn_text: 'Validálás',
                title: 'Validálás',
                event_name: "customClick",
                class: "btn btn-outline-teal",
                event_payload: 'showValidatePopup',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Vizsgálati lap nyomtatása',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                event_payload: 'printRowOpinion'
            },
            {
                btn_text: '<i class="fas fa-print"></i>',
                title: 'Alkalmassági vélemény nyomtatás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'printRow'
            },
            {
                btn_text: '<i class="fas fa-history"></i>',
                title: 'Előzmények',
                event_name: "customClick",
                class: "btn btn-outline-purple",
                event_payload: 'showHistory'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'modifyRow',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-unlock"></i>',
                title: 'Felnyitás',
                event_name: "customClick",
                class: "btn btn-outline-info",
                event_payload: 'seeEdit',
                additionalButtonVisible: "isDocumentValidatedReopen",
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow',
                additionalButtonVisible: "isDocumentValidated",
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "companySite.siteName",
                label: "Ellátóhely",
                visibility: true,
            },
            {
                name: "treatment.startDate",
                label: "Vizsgálat időpontja",
                slot_name: "startDate_format",
                visibility: true,
            },
            {
                name: "treatment.doctor.fullName",
                label: "Vizsgálatot végző orvos",
                visibility: true,
            },
            {
                name: "siteGroupPatient.siteGroup.name",
                label: "Munkakör",
                visibility: true
            },
            {
                name: "capableStatus.text",
                label: "Alkalmasság",
                visibility: true
            },
            {
                name: "validity",
                label: "Érvényességi idő",
                visibility: true,
                slot_name: "date_format",
                sort: true,
                formVisible: true,
                formSize: 3,
                formType: "date",
                formRequired: true,
                viewModalShow: true
            },
            {
                name: "createdOn",
                label: "Létrehozás időpontja",
                slot_name: "created_on_format",
                visibility: true
            },
            {
                name: "validated",
                label: "Státusz",
                visibility: true,
                slot_name: "validated_format",
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ]
    }
}
